import { render, staticRenderFns } from "./AssignLevelModal.vue?vue&type=template&id=fecbd0b6&"
import script from "./AssignLevelModal.vue?vue&type=script&lang=js&"
export * from "./AssignLevelModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignLevelModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports